import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

const _hoisted_3 = {
  class: "base_main_header"
};
import StatusBar from "@com/StatusBar.vue";
import MemberTable from '@com/member/MemberTable.vue';
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import api from "@api/member";
import $ from "@util/base";
import useRoute from "@util/router";
export default {
  __name: 'MemberManager',

  setup(__props) {
    const config = {
      type: 'membermanager'
    };
    const route = useRoute();
    route.watchRouter(config.type, () => {
      getNum();
    });
    const statusList = reactive([{
      label: "全部",
      value: "all",
      total: 0
    }, {
      label: "正常",
      value: "1030001",
      total: 0
    }, {
      label: "封禁",
      value: "1030002",
      total: 0
    }]);
    const name = ref(route.query().name || "");
    const login = ref(route.query().login || "");

    function searchName(val) {
      route.replaceQuery("name", val);
    }

    function searchLogin(val) {
      route.replaceQuery("login", val);
    }

    getNum();

    function getNum() {
      let routeQuery = route.query();
      api.num({
        loginName: routeQuery.login,
        nickname: routeQuery.name,
        memberType: "1009001"
      }, val => {
        statusData(val);
      });
    }

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    function getExport() {
      let routeQuery = route.query();
      api.export(config.type, {
        loginName: routeQuery.login,
        nickname: routeQuery.name,
        memberStatus: routeQuery.status
      }, val => {
        $.download(val.url, "会员列表导出");
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_main = _resolveComponent("el-main");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => name.value = $event),
              "onKeyup[native]": searchName,
              onChange: searchName,
              placeholder: "姓名",
              "suffix-icon": _unref(Search),
              clearable: ""
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: login.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => login.value = $event),
              "onKeyup[native]": searchLogin,
              onChange: searchLogin,
              placeholder: "账号",
              "suffix-icon": _unref(Search),
              clearable: ""
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(StatusBar, {
          data: statusList,
          default: "all"
        }, null, 8, ["data"]), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          text: "",
          onClick: getExport
        }, {
          default: _withCtx(() => [_createTextVNode("导出")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('EXPORT')]])]), _createVNode(MemberTable, {
          type: config.type,
          onGetNum: getNum
        }, null, 8, ["type"])]),
        _: 1
      })]);
    };
  }

};